<!-- <span id="copyright">Site design © 2023 <a href="https://ransackgames.com/" target="_blank">Ransack Games</a></span> -->

<div id="status" (click)="toggleFreedom(!isLiberated())">
    <div>{{ isLiberated() ? '🗽' : '🔒' }}</div>
</div>
<div [hidden]="connected==false" id="users" (click)="openUsers()">Online Users: {{ users.length }}</div>
<div [hidden]="connected==true" class="status">Disconnected</div>
<div style="flex: 1;"></div>
<ng-container *ngIf="settings != null">
    <div class="mousetype" (click)="cycleMousetype()" (contextmenu)="cycleMousetype(-1)" [ngStyle]="{'background-color': mousetypecolor }" [innerHTML]="mousetypeHTML"></div>
    <ng-container *ngIf="fullAccess">
        <div (click)="cycleAlignment()" (contextmenu)="cycleAlignment(-1)" [ngStyle]="{'background-color': divisorcolor }">
            <span><u>A</u>lign </span>
            <span>1 / {{settings.alignment}}</span>
        </div>
    </ng-container>
    <div class="toggle" (click)="toggleSnap()" [ngClass]="{'active': settings.snapping}">
        <u>S</u>nap
    </div>
    <div class="toggle" (click)="toggleErase()" [ngClass]="{'active': settings.erasing}">
        <u>E</u>rase
    </div>
</ng-container>
<div class="setzoom out" (click)="setZoom('out')">-</div>
<div class="center" (click)="setZoom()">Zoom {{zoom.x | percent}}</div>
<div class="setzoom" (click)="setZoom('in')">+</div>
<div id="position" (click)="moveCenter()">({{position.x}}, {{position.y}})</div>